"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var index_1 = require("./index");
var SETTINGS_SEARCHABLE_FIELDS = ["name", "isActive", "user.username"];
var UserNotificationsSettingsStore = /** @class */ (function (_super) {
    tslib_1.__extends(UserNotificationsSettingsStore, _super);
    function UserNotificationsSettingsStore(socketService, notificationsStore, storageService) {
        var _this = _super.call(this, notificationsStore, SETTINGS_SEARCHABLE_FIELDS, "Setting", "updated") || this;
        _this.socketService = socketService;
        _this.notificationsStore = notificationsStore;
        _this.storageService = storageService;
        _this.getItems = function (userId) {
            var _a;
            if (_this.isLoading) {
                return;
            }
            mobx_1.transaction(mobx_1.action(function () {
                _this.isLoading = true;
                _this.selectedValues = [];
                _this.setPromptDeleteItem(null);
            }));
            var sort = (_a = {},
                _a[_this.sortBy] = _this.sortDir,
                _a);
            _this.socketService.getNotificationsSettingsById(userId)
                .then(function (res) { return _this.onLoadItemsSuccess(res); })
                .catch(function (res) { return _this.onLoadItemsError(res); });
        };
        _this.onUpdateEventNotificationsSettings = function (data) {
            _this.isLoading = true;
            _this.onLoadSuccess(data);
        };
        _this.updateSetting = function (id, key, value) {
            var idx = _this.items.findIndex(function (setting) { return setting._id === id; });
            if (idx >= 0) {
                _this.items[idx][key] = value;
                var data = {};
                data[key] = value;
                _this.onUpdate(id, data);
            }
        };
        _this.onUpdate = function (id, data) {
            _this.socketService.updateSetting(id, data)
                .then(mobx_1.action(function (res) { return _this.onUpdateSuccess(res); }))
                .catch(function () { return _this.onUpdateFailed(); });
        };
        _this.setColumnsWidth = function (columnsWidth) {
            _this.storageService.setColumnsWidth("notification_settings", columnsWidth);
        };
        _this.getColumnsWidth = function () {
            var columnsWidth = _this.storageService.getColumnsWidth("notification_settings");
            return columnsWidth || { 0: 460, 1: 205, 2: 270, 3: 270, 4: 270, 5: 230, 6: 230, 7: 150 };
        };
        _this.deleteItem = function () {
            _this.socketService.deleteSetting(_this.promptDeleteItem._id)
                .then(function () { return _this.onDeleteItemSuccess(_this.promptDeleteItem._id); })
                .catch(function () { return _this.onDeleteItemError(); });
        };
        return _this;
    }
    UserNotificationsSettingsStore.prototype.reset = function () {
        var _this = this;
        _super.prototype.reset.call(this);
        mobx_1.transaction(function () {
            _this.isLoading = false;
            _this.loadError = false;
            _this.items = mobx_1.observable.array([]);
        });
    };
    UserNotificationsSettingsStore.prototype.onLoadItemsSuccess = function (res) {
        var _this = this;
        mobx_1.transaction(function () {
            _this.items = res;
            _this.count = res.length;
            _this.isLoading = false;
        });
    };
    UserNotificationsSettingsStore.prototype.onLoadSuccess = function (data) {
        var _this = this;
        if (data) {
            mobx_1.transaction(function () {
                _this.isLoading = false;
                _this.items = data;
            });
        }
        this.isLoading = false;
    };
    UserNotificationsSettingsStore.prototype.onUpdateSuccess = function (res) {
        this.notificationsStore.pushSuccessNotification({
            title: "Operation Complete",
            text: "Setting updated successfully",
            timeout: 3000
        });
    };
    UserNotificationsSettingsStore.prototype.onUpdateFailed = function () {
        this.notificationsStore.pushErrorNotification({
            title: "Operation Failed",
            text: "Faild to update notifications settings",
            timeout: 5000
        });
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], UserNotificationsSettingsStore.prototype, "loadError", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], UserNotificationsSettingsStore.prototype, "reset", null);
    tslib_1.__decorate([
        mobx_1.action
    ], UserNotificationsSettingsStore.prototype, "getItems", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], UserNotificationsSettingsStore.prototype, "onLoadItemsSuccess", null);
    tslib_1.__decorate([
        mobx_1.action
    ], UserNotificationsSettingsStore.prototype, "onLoadSuccess", null);
    tslib_1.__decorate([
        mobx_1.action
    ], UserNotificationsSettingsStore.prototype, "onUpdateEventNotificationsSettings", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], UserNotificationsSettingsStore.prototype, "updateSetting", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], UserNotificationsSettingsStore.prototype, "onUpdate", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], UserNotificationsSettingsStore.prototype, "onUpdateSuccess", null);
    tslib_1.__decorate([
        mobx_1.action
    ], UserNotificationsSettingsStore.prototype, "onUpdateFailed", null);
    tslib_1.__decorate([
        mobx_1.action
    ], UserNotificationsSettingsStore.prototype, "deleteItem", void 0);
    return UserNotificationsSettingsStore;
}(index_1.BaseListStore));
exports.default = UserNotificationsSettingsStore;
